import {
  ONBOARDING_PRODUCTS,
  ONBOARDING_SEGMENTS,
} from "../../constants";

// The 10 named tabs of the new coach onboarding wizard. `key` maps to the
// onboardingWizard.tabs.* i18n key. Tabs 9 + 10 are scaffolded only and are
// handed off to the existing Setup Wizard after provisioning.
export const WIZARD_STEPS = [
  { id: 1, key: "profile" },
  { id: 2, key: "aboutYou" },
  { id: 3, key: "products" },
  { id: 4, key: "branding" },
  { id: 5, key: "logoAndSplash" },
  { id: 6, key: "preferences" },
  { id: 7, key: "exerciseLibrary" },
  { id: 8, key: "buildingApp" },
  { id: 9, key: "appWizard", scaffold: true },
  { id: 10, key: "settings", scaffold: true },
];

export const TOTAL_STEPS = WIZARD_STEPS.length;

// Last step a user can interactively reach in this wizard (Building App).
// 9 + 10 belong to the Setup Wizard ticket.
export const LAST_INTERACTIVE_STEP = 8;

export const STEPS_WITH_SKIP = new Set([5, 7]); // Logo & Splash, Exercise Library

const { COACH, GYM, BOTH } = ONBOARDING_SEGMENTS;
const { PULL, PUSH, PERFORM, PRESS } = ONBOARDING_PRODUCTS;

// Which products surface on the Products step, by segment.
export const PRODUCTS_BY_SEGMENT = {
  [COACH]: { coaching: [PULL, PUSH], gym: [] },
  [GYM]: { coaching: [], gym: [PERFORM, PRESS] },
  [BOTH]: { coaching: [PULL, PUSH], gym: [PERFORM, PRESS] },
};

// Self-serve products activate instantly; sales-led products open a Typeform.
export const SELF_SERVE_PRODUCTS = new Set([PULL, PUSH]);
export const SALES_PRODUCTS = new Set([PERFORM, PRESS]);

export const isSelfServe = (product) => SELF_SERVE_PRODUCTS.has(product);
export const isSalesProduct = (product) => SALES_PRODUCTS.has(product);

// Product card metadata. Copy lives in i18n (onboardingWizard.products.*).
export const PRODUCT_META = {
  [PULL]: { name: "PULL", initials: "PL", recommended: true },
  [PUSH]: { name: "PUSH", initials: "PS", recommended: true },
  [PERFORM]: { name: "PERFORM", initials: "PF", recommended: false },
  [PRESS]: { name: "PRESS", initials: "PR", recommended: false },
};
